import { render, staticRenderFns } from "./BoxLine.vue?vue&type=template&id=1ca272f6&scoped=true&"
import script from "./BoxLine.vue?vue&type=script&lang=js&"
export * from "./BoxLine.vue?vue&type=script&lang=js&"
import style0 from "./BoxLine.vue?vue&type=style&index=0&id=1ca272f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca272f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ca272f6')) {
      api.createRecord('1ca272f6', component.options)
    } else {
      api.reload('1ca272f6', component.options)
    }
    module.hot.accept("./BoxLine.vue?vue&type=template&id=1ca272f6&scoped=true&", function () {
      api.rerender('1ca272f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box-close/components/BoxLine.vue"
export default component.exports